export const SIMPLE = 'SIMPLE';
export const EMAIL = 'EMAIL';
export const CRM = 'CRM';